import { Action } from '@ngrx/store';

export enum LayoutActionTypes {
  ToggleFullScreen = '[Layout] Toggle Full Screen',
  UpdateFullScreenModeFailed = '[Layout] Update Full Screen Mode Failed'
}

export class ToggleFullScreen implements Action {
  readonly type = LayoutActionTypes.ToggleFullScreen;
}

export class UpdateFullScreenModeFailed implements Action {
  readonly type = LayoutActionTypes.UpdateFullScreenModeFailed;
  constructor(public payload: Error) {}
}

export type LayoutActions =
  | ToggleFullScreen
  | UpdateFullScreenModeFailed;
